import React, { Fragment } from "react";
import PropTypes from "prop-types";
import startCase from "lodash/startCase";
import { cellGrow } from "constants/styles";
import Pill from "components/Pill";
import getUnicodeFlagIcon from "country-flag-icons/unicode";
import { TaxRatePropTypes } from "utils/propTypes";
import { TAX_RATE_CLUSIVITY } from "utils/constants/taxRate";
import { PILL_THEME } from "components/Pill";

const TaxRateOption = ({ model, isFirst, isLast, isActive, onClick }) => {
  const { id, displayName, percentage, inclusive, country } = model;

  const clusivity = inclusive
    ? TAX_RATE_CLUSIVITY.INCLUSIVE
    : TAX_RATE_CLUSIVITY.EXCLUSIVE;

  return (
    <div
      className="hairline-1 ba br2 bg-white w-100 relative cell-grow bg-white--hover"
      onClick={() => onClick(id)}
    >
      <div className="flex flex-column bb hairline-1 justify-between">
        <div className="ph2 pv2 flex flex-row justify-between pointer">
          <div className="flex flex-row justify-between pointer w-100 overflow-hidden">
            <div className="flex flex-column justify-between">
              <div className="f5 fw5 lh-title word-break">{displayName}</div>
            </div>
            <div className="flex flex-column items-end flex-shrink-0">
              <div className="f4 fw6 lh-title flex-shrink-0">{percentage}</div>
              <div className="pt2">
                <Pill
                  theme={PILL_THEME.SLIM}
                  copy={startCase(clusivity.toLowerCase())}
                />
              </div>
            </div>
          </div>
        </div>
        {country && (
          <Fragment>
            <div style={{ height: 43 }} className="w-100"></div>
            <div className="absolute bottom-0 right-0 left-0 z-1 center flex flex-row justify-between items-center w-100 bt hairline-1 pa2 bg-white f6">
              <div className="f5 lh-title truncate fw5">
                {country && getUnicodeFlagIcon(country)}
              </div>
            </div>
          </Fragment>
        )}
      </div>
      <style jsx>{cellGrow}</style>
    </div>
  );
};

TaxRateOption.propTypes = {
  model: PropTypes.shape({
    ...TaxRatePropTypes,
    adminUrl: PropTypes.string,
    createdAt: PropTypes.string
  }),
  isFirst: PropTypes.bool,
  isLast: PropTypes.bool,
  isActive: PropTypes.bool,
  onClick: PropTypes.func
};

export default TaxRateOption;
